// commandSafetyExtra.js — FASE-11 E3-WS1-T03 (SEC). GUARD PARALELO ao SACRED commandSafety.js
// (que é byte-frozen e protegido pelo integrityGuard — NÃO pode ser editado). A regra SAGRADA
// já bloqueia `curl|wget … | sh/bash/zsh/dash/fish` (baixar+executar no shell), mas NÃO cobre:
//   • pipe de fetch remoto direto num INTERPRETADOR: `curl … | node`, `wget … | python3`
//   • command-substitution de fetch remoto: `eval "$(curl …)"`, `sh -c "$(curl …)"`, `` `curl …` ``
// Todas executam código remoto sem inspeção — o mesmo threat model da regra SAGRADA, só com a
// boca diferente. Este módulo estende a cobertura SEM tocar o arquivo frozen; é chamado no MESMO
// ponto do gate do run_command (agentTools.js), em série com classifyCommandRisk (defense-in-depth).
// PURO, no-throw, sem I/O — unit-testável.

const REMOTE = '(?:sudo\\s+)?(?:curl|wget)\\b';
/** @type {Array<[RegExp, string]>} */
const RULES = [
  // pipe de fetch remoto num interpretador (node/deno/bun/python/ruby/perl/php/osascript)
  [
    new RegExp(`\\b${REMOTE}[^\\n|]*\\|\\s*(?:sudo\\s+)?(?:node|deno|bun|python3?|ruby|perl|php|osascript)\\b`, 'i'),
    'pipe de fetch remoto num interpretador (curl|wget … | node/python/…) — executa código remoto sem inspeção',
  ],
  // eval/exec de command-substitution de fetch remoto: eval "$(curl …)" / exec $(wget …)
  [
    new RegExp(`\\b(?:eval|exec)\\b[^\\n]*\\$\\(\\s*${REMOTE}`, 'i'),
    'eval/exec de fetch remoto via $() — executa código remoto sem inspeção',
  ],
  // shell -c de command-substitution de fetch remoto: sh -c "$(curl …)"
  [
    new RegExp(`\\b(?:sh|bash|zsh|dash|fish)\\s+-c\\b[^\\n]*\\$\\(\\s*${REMOTE}`, 'i'),
    'sh -c "$(curl …)" — executa código remoto sem inspeção',
  ],
  // substituição por crase (legado): eval `curl …` / sh -c `wget …`
  [
    new RegExp(`\\b(?:eval|exec|(?:sh|bash|zsh|dash|fish)\\s+-c)\\b[^\\n]*` + '`' + `\\s*${REMOTE}`, 'i'),
    'substituição por crase de fetch remoto (`curl …`) — executa código remoto sem inspeção',
  ],
];

/**
 * Risco de execução de código REMOTO não coberto pela regra SAGRADA (curl|sh).
 * @param {string} command
 * @returns {{ blocked: boolean, reason?: string }}
 */
export function remoteExecRisk(command) {
  if (typeof command !== 'string' || !command.trim()) return { blocked: false };
  for (const [re, reason] of RULES) {
    if (re.test(command)) return { blocked: true, reason };
  }
  return { blocked: false };
}
